import React from 'react';
import { Card, CardActions, CardHeader, CardMedia } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';

const LocationTile = ({ location, onEditPressed, style, ...rest }) => (
  <Card {...rest} style={{ ...style, marginBottom: 15, height: '100%', maxWidth: 400 }} >
    <CardHeader
      title={location.name}
      subtitle={location.address}
    />
    <CardMedia>
      <img src={location.imageUrl} alt="" style={{ height: 180 }} />
    </CardMedia>
    <CardActions style={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'flex-end' }}>
      <RaisedButton label="Edit Details" primary onTouchTap={onEditPressed}/>
    </CardActions>
  </Card>
);

export default LocationTile;



// WEBPACK FOOTER //
// ./src/components/LocationTile.js